import axios from "axios";
export default async function fetchDataFromIPFS(uri) {
    try {
        const response = await axios.get(uri);
        return response.data;
    } catch (error) {
        throw new Error("IPFS upload failed" + error);
    }
}
